import { render, staticRenderFns } from "./CountriesList.vue?vue&type=template&id=97747524&"
import script from "./CountriesList.vue?vue&type=script&lang=js&"
export * from "./CountriesList.vue?vue&type=script&lang=js&"
import style0 from "./CountriesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports